import { render, staticRenderFns } from "./billing-partner-selection.vue?vue&type=template&id=66f1ac1f&"
import script from "./billing-partner-selection.vue?vue&type=script&lang=ts&"
export * from "./billing-partner-selection.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports